import { getConfigTenant, isCorpTenant, isVesperTenant } from "./getTenant";

export const getPortalName = () => {
  const isCorporate = isCorpTenant(getConfigTenant());
  const isVesper = isVesperTenant(getConfigTenant());
  return isCorporate
    ? "Capital One Business Travel"
    : isVesper
    ? "Vesper Travel"
    : "Capital One Travel";
};
